import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";
import Select from "../../components/Select";
import TextArea from "../../components/TextArea";

const purpose = [
  "-- select --",
  "Change Phone",
  "Payment Support",
  "Other Support",
];
const previousTicket = ["New Complaint"];

const SupportTicketPage = () => {
  const [data, setData] = useState({
    purpose: "",
    newComplaint: "",
    questions: "",
    image: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_supportticket_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_supporttickett_form_card"
      >
        <div className="mono_section_title">
          <h2>Support Ticket</h2>
        </div>
        <div className="mono_supportticket_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Select
                label="Purpose"
                className="select_field"
                value={data.purpose}
                name="purpose"
                onChange={(e) => setData({ ...data, purpose: e.target.value })}
                options={purpose}
              />
            </div>
            <div className="form_group">
              <Select
                label="Previous Ticket Reference"
                className="select_field"
                value={data.newComplaint}
                name="newComplaint"
                onChange={(e) =>
                  setData({ ...data, newComplaint: e.target.value })
                }
                options={previousTicket}
              />
            </div>
            <div className="form_group">
              <TextArea
                label="Your Question"
                name="questions"
                cols="30"
                rows="10"
                onChange={(e) =>
                  setData({ ...data, questions: e.target.value })
                }
                className="question_field"
                placeholder="Write your questions..."
              />
            </div>
            <div className="form_group">
              <Input
                label="Image"
                type="file"
                name="image"
                placeholder="Enter your user id"
                onChange={(e) => setData({ ...data, image: e.target.value })}
                className="input_field"
              />
            </div>
            <Button type="submit" className="submit_btn">
              submit
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default SupportTicketPage;
